import { render } from "./BaseModalReplaceArticles.vue?vue&type=template&id=6191e548&scoped=true"
import script from "./BaseModalReplaceArticles.vue?vue&type=script&lang=js"
export * from "./BaseModalReplaceArticles.vue?vue&type=script&lang=js"

import "./BaseModalReplaceArticles.vue?vue&type=style&index=0&id=6191e548&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6191e548"]])

export default __exports__